import { NavLink } from 'react-router';

import { useDrawer } from '@/hooks/useDrawer';
import { useResponsive } from '@/hooks/useResponsive';
import { Flex } from '@/layouts/Flex';
import { Icon } from '../Icon';
import styles from './styles.module.scss';

const LINKS = [
  { path: '/', label: 'Inicio' },
  { path: '/reviews', label: 'Videos' },
  { path: '/how-to-reviews', label: 'Videos explicativos' },
  { path: '/pictograms', label: 'Pictogramas' },
  { path: '/about', label: 'Acerca del proyecto' }
] as const;

export function Navbar() {
  const { isMobile } = useResponsive();
  const { setIsDrawerOpen, setDrawerChild } = useDrawer();

  const handleOpenDrawer = () => {
    setDrawerChild(
      <ul className={styles.navLinks}>
        {LINKS.map(({ path, label }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) => (isActive ? styles.active : '')}
              onClick={() => setIsDrawerOpen(false)}>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    );
    setIsDrawerOpen(true);
  };

  return (
    <nav className={styles.nav}>
      <Flex justifyContent='space-between' alignItems='center' className={styles.navContainer}>
        {/* <span>DienTEA</span> */}
        <img src='/identity/svg/full_horizontal/type_1.svg' loading='lazy' alt='logo' className={styles.image} />
        {isMobile ? (
          <button className={styles.menuButtonContainer} onClick={handleOpenDrawer}>
            <Icon name='menu' color='#fff' size={20} />
          </button>
        ) : (
          <ul className={styles.navLinks}>
            {LINKS.map(({ path, label }) => (
              <li key={path}>
                <NavLink to={path} className={({ isActive }) => (isActive ? styles.active : '')}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
      </Flex>
    </nav>
  );
}
